import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { getTranslation } from '../actions/dataActions'
import ChargingKiosk from '../kiosk/components/ChargingKiosk'
import TitleBar from '../kiosk/components/TitleBar'
import { getSyncCustomer } from '../actions/receiptActions'
import { resetCustomer } from '../actions/receiptActions.js'

class ChargingKioskPage extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            timerid: -1
        };
        this.getSessionTimeout = this.getSessionTimeout.bind(this);
    }

    componentDidMount()
    {
      this.setState({ timerid: this.getSessionTimeout() });
    }

    componentWillUnmount()
    {
      clearTimeout(this.state.timerid);
    }

    getSessionTimeout()
    {
      const {
        customer
      } = this.props;

        if (this.state.timerid)
        {
            clearTimeout(this.state.timerid);
        }
        //Na 60 seconden klant uitloggen
        if (customer && customer.customerid > 0)
        {
          this.timerid = setInterval(() =>
          {
            this.props.resetCustomer(true);
          }, 1000);
        }
        return this.timerid;
    }

    componentDidUpdate() {
      const {
        customer
      } = this.props;

      //Na 60 seconden klant uitloggen
      if (customer && customer.customerid > 0)
      {
        this.getSessionTimeout();
      }
    }

    render() {     
      return(
          <div id="app">
            <div id="main-container-chargingkiosk">
              <TitleBar />
              <ChargingKiosk/>
            </div>
          </div>
      )
    }
}

ChargingKioskPage.propTypes = {
      getTranslation: PropTypes.func
}

function mapStateToProps(state) {
    return {
      customer: state.receiptState.receipt.customer
    }
}

export default connect(mapStateToProps,
{
  getTranslation,
  getSyncCustomer,
  resetCustomer
 })(ChargingKioskPage)



// WEBPACK FOOTER //
// src/pages/ChargingKioskPage.jsx